module.exports = __webpack_public_path__ + "img/zczg_jxk.4b4c58b0.svg";